// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hpp {
  margin: 0 16px 16px;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hpp__quest,
.hpp__map-card {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  padding: 16px 18px 14px;
  background: var(--surface-color, #fff);
  border: 1px solid var(--border-color, rgba(8, 119, 188, 0.22));
  box-shadow: 0 10px 28px var(--shadow-color, rgba(8, 55, 90, 0.08));
}

.hpp__quest::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: linear-gradient(
    180deg,
    var(--brand-primary, #0877bc) 0%,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) 100%
  );
}

.hpp__quest-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.hpp__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.hpp__streak,
.hpp__xp {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary, #5b6b7c);
}

.hpp__title {
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 750;
  color: var(--text-color, #1a2b3c);
}

.hpp__club,
.hpp__home {
  margin: 0 0 6px;
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--text-color, #1a2b3c);
}

.hpp__home {
  color: var(--text-secondary, #5b6b7c);
  font-size: 0.86rem;
}

.hpp__season {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 8px;
  align-items: center;
  margin-top: 10px;
}

.hpp__season-label {
  font-size: 11px;
  font-weight: 650;
  color: var(--text-secondary, #5b6b7c);
}

.hpp__season-track {
  height: 6px;
  border-radius: 99px;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  overflow: hidden;
}

.hpp__season-fill {
  display: block;
  height: 100%;
  border-radius: 99px;
  background: var(--brand-primary, #0877bc);
}

.hpp__season-num {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary, #5b6b7c);
}

.hpp-map {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.hpp-map__terrace {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, transparent);
}

.hpp-map__terrace.is-locked {
  opacity: 0.55;
}

.hpp-map__order {
  width: 22px;
  height: 22px;
  border-radius: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  flex-shrink: 0;
}

.hpp-map__terrace.is-locked .hpp-map__order {
  background: #8a97a6;
}

.hpp-map__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.hpp-map__name {
  font-size: 12px;
  font-weight: 650;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hpp-stars {
  letter-spacing: 0.04em;
  line-height: 1;
}

.hpp-stars--md {
  font-size: 12px;
}

.hpp-stars--sm {
  font-size: 11px;
}

.hpp-stars .is-on {
  color: #f5b301;
}

.hpp-stars .is-off {
  color: rgba(128, 128, 128, 0.45);
}

.hpp-stars.is-locked .is-off {
  color: rgba(128, 128, 128, 0.28);
}

.hpp__link {
  margin-top: 12px;
  border: none;
  background: none;
  color: var(--brand-primary, #0877bc);
  font-weight: 700;
  font-size: 0.86rem;
  cursor: pointer;
  padding: 0;
}

.hpp__link:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

@media (max-width: 560px) {
  .hpp-map {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomePlayerPath.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,8DAA8D;EAC9D,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".hpp {\n  margin: 0 16px 16px;\n  max-width: 900px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.hpp__quest,\n.hpp__map-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  padding: 16px 18px 14px;\n  background: var(--surface-color, #fff);\n  border: 1px solid var(--border-color, rgba(8, 119, 188, 0.22));\n  box-shadow: 0 10px 28px var(--shadow-color, rgba(8, 55, 90, 0.08));\n}\n\n.hpp__quest::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: linear-gradient(\n    180deg,\n    var(--brand-primary, #0877bc) 0%,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) 100%\n  );\n}\n\n.hpp__quest-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.hpp__eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.hpp__streak,\n.hpp__xp {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-secondary, #5b6b7c);\n}\n\n.hpp__title {\n  margin: 0 0 8px;\n  font-size: 1.05rem;\n  font-weight: 750;\n  color: var(--text-color, #1a2b3c);\n}\n\n.hpp__club,\n.hpp__home {\n  margin: 0 0 6px;\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: var(--text-color, #1a2b3c);\n}\n\n.hpp__home {\n  color: var(--text-secondary, #5b6b7c);\n  font-size: 0.86rem;\n}\n\n.hpp__season {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 8px;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.hpp__season-label {\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--text-secondary, #5b6b7c);\n}\n\n.hpp__season-track {\n  height: 6px;\n  border-radius: 99px;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  overflow: hidden;\n}\n\n.hpp__season-fill {\n  display: block;\n  height: 100%;\n  border-radius: 99px;\n  background: var(--brand-primary, #0877bc);\n}\n\n.hpp__season-num {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary, #5b6b7c);\n}\n\n.hpp-map {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.hpp-map__terrace {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, transparent);\n}\n\n.hpp-map__terrace.is-locked {\n  opacity: 0.55;\n}\n\n.hpp-map__order {\n  width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 800;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.hpp-map__terrace.is-locked .hpp-map__order {\n  background: #8a97a6;\n}\n\n.hpp-map__body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.hpp-map__name {\n  font-size: 12px;\n  font-weight: 650;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hpp-stars {\n  letter-spacing: 0.04em;\n  line-height: 1;\n}\n\n.hpp-stars--md {\n  font-size: 12px;\n}\n\n.hpp-stars--sm {\n  font-size: 11px;\n}\n\n.hpp-stars .is-on {\n  color: #f5b301;\n}\n\n.hpp-stars .is-off {\n  color: rgba(128, 128, 128, 0.45);\n}\n\n.hpp-stars.is-locked .is-off {\n  color: rgba(128, 128, 128, 0.28);\n}\n\n.hpp__link {\n  margin-top: 12px;\n  border: none;\n  background: none;\n  color: var(--brand-primary, #0877bc);\n  font-weight: 700;\n  font-size: 0.86rem;\n  cursor: pointer;\n  padding: 0;\n}\n\n.hpp__link:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n@media (max-width: 560px) {\n  .hpp-map {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
